const initState = {
    uri: 'https://yrh-oau-be.vercel.app/api/'
}

const ApiReducer = (state=initState, action)=>{
    return state
}

export default ApiReducer